import React, { useEffect, useState } from 'react';
import Loader from '../../../common/Loader';
import { useFetchCheckbetTicket } from '../../../data/fetchCheckbetTicket';
import { getLabel } from '../../../data/labels';
import BetInfo from './BetInfo';
import EventsList from './EventsList';
import { getConfiguration } from '../../utils/configuration';
import ToggleNotifications from './ToggleNotifications';

function SingleBetTicket(props) {
    const [data, setData] = useState(null);
    const [state, dispatch] = useFetchCheckbetTicket(props.ticket.id, props.toggled, props.ticket.isLive, false, true);
    const conf = getConfiguration();

    useEffect(() => {
        if (props.index && !props.toggled) {
            props.toggleTicket(props.ticket.id);
        }
    }, []);


    useEffect(() => {
        if (state.data != null && !state.isError) {
            setData(state.data);
        }
    }, [state.data, state.isError]);

    function toggleMatches() {
        props.toggleTicket(props.ticket.id);
    }

    const getEsitoClass = function (eventStatus, winning, winningDrawCode) {
        if (eventStatus === 'voided') return 'esito-vd';
        if (!['winning', 'losing'].includes(eventStatus) || !winningDrawCode) return 'esito-nd';
        return winning ? 'esito-v' : 'esito-p';
    };

    return (
        <div className="mybet-container d-flex flex-column | mb_5">
            <div className="d-flex justify-content-space-between align-items-center margine-su-giu bold pointer details-toggle | mb_5_1" onClick={toggleMatches}>
                <span className="text-big bold | mb_5_1_1">{getLabel('mybets.singola')}</span>
                <span className="margine-sx margin-right-auto | mb_5_1_2">
                    {props.ticket.funBonus &&
                        <span className="cg-mybet-funbonus | mb_5_1_2_1">{getLabel('mybets.funbonus')}</span>
                    }
                    {props.ticket.freeBet &&
                        <span className="cg-mybet-funbonus | mb_5_1_2_3">{getLabel('mybets.freebet')}</span>
                    }
                    {props.ticket.isBetBuilder &&
                        <span className="cg-mybet-funbonus | mb_5_1_2_3">{getLabel('betbuilder.title')}</span>
                    }
                </span>
                <span className="visibility-hidden | mb_5_1_4">{getLabel('mybets.singola')}</span>
                <span className="mb_5_1_3">
                    <i className={`mb_5_1_3__${props.toggled ? 'less' : 'more'}`}></i>
                </span>
            </div>
            <div className='mybet-container__event-list__wrapper'>
                {state.data != null && state.data.events.map((event, i) =>
                    event.bets.map((bet, j) => (
                        <div key={`${i}-${j}`} className="event-list__outcome-symbol">
                            <span className={"esito | mb_10_3_2_1_3 " + getEsitoClass(bet.state, bet.isWinning, bet.winningDrawCode)}></span>
                        </div>
                    ))
                )}
            </div>

            <hr className="mb_4" />

            {props.toggled && (
                data == null
                    ? <Loader error={state.isError} />
                    : <div className="mybet-events-container | mb_6">
                        {conf.pnc?.enabled && <ToggleNotifications state={state} dispatch={dispatch} />}
                        <EventsList events={data.events} isBetBuilder={data.betBuilder} isCheckbet={false} />
                      </div>
            )}

            <div className="light-grey-bg | mb_5_3">
                <BetInfo ticket={props.ticket} isCheckbet={false} />
            </div>
        </div>
    );
}

export default SingleBetTicket;